import React from "react";
import useAuth from "@flow/components/auth/";
import LinkButton from "@flow/components/ui/button/LinkButton";
import InfoBox from "./InfoBox";
import { FormattedMessage } from "react-intl";

export default function Authentication() {
  const { doSignOut, user } = useAuth();

  return (
    <div
      style={
        !user
          ? {
              display: "flex",
              justifyContent: "space-between",
              flexGrow: 1,
              alignItems: "center",
              padding: 8,
            }
          : {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              flexGrow: 1,
              alignItems: "center",
              padding: 8,
            }
      }
    >
      <InfoBox />
      {user && (
        <LinkButton
          label={<FormattedMessage id={"myFlow.logout"} />}
          onClick={() => doSignOut()}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/auth/Authentication.tsx